import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaUpload, FaTimes } from 'react-icons/fa';
import { validateImageFile, convertImageToBase64 } from '../../utils/imageConverter';
import styles from './ImageUpload.module.css';

const ImageUpload = ({ onImageSelect, disabled }) => {
  const { t } = useLanguage();
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setError(null);

    try {
      // Validate file
      validateImageFile(file);

      // Create preview
      const previewUrl = URL.createObjectURL(file);
      setPreview(previewUrl);

      // Convert to base64
      const base64 = await convertImageToBase64(file);

      // Callback to parent
      onImageSelect(base64, file);
    } catch (err) {
      setError(err.message);
      setPreview(null);
    }
  };

  const handleClear = () => {
    setPreview(null);
    setError(null);
    onImageSelect(null, null);
  };

  return (
    <div className={styles.container}>
      {!preview ? (
        <label className={styles.uploadArea}>
          <input
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/webp"
            onChange={handleFileChange}
            disabled={disabled}
            className={styles.fileInput}
          />
          <FaUpload className={styles.uploadIcon} />
          <p className={styles.uploadText}>{t('upload_image')}</p>
          <p className={styles.uploadHint}>{t('drag_drop')}</p>
        </label>
      ) : (
        <div className={styles.previewContainer}>
          <img src={preview} alt="Preview" className={styles.preview} />
          <button
            type="button"
            className={styles.clearButton}
            onClick={handleClear}
            disabled={disabled}
          >
            <FaTimes />
          </button>
        </div>
      )}

      {error && (
        <p className={styles.error}>{error}</p>
      )}
    </div>
  );
};

export default ImageUpload;
